import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BarChart3 } from "lucide-react";

/**
 * Componente Infographic
 * Exibe uma imagem ou SVG de infográfico gerada via DALL-E ou Gemini
 */
const Infographic = ({ infographicData }) => {
  if (!infographicData) {
    return (
      <Card className="card">
        <CardContent className="p-8 text-center">
          <BarChart3 className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <p className="text-gray-500">Infográfico não disponível para este vídeo</p>
        </CardContent>
      </Card>
    );
  }

  // Se for um infográfico de imagem (DALL-E)
  if (infographicData.type === 'image' && infographicData.url) {
    return (
      <Card className="card">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="flex items-center gap-2">
              <BarChart3 className="w-5 h-5 text-blue-600" />
              Infográfico
            </CardTitle>
            <Badge variant="secondary">Imagem DALL-E</Badge>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg overflow-hidden bg-gray-100 border border-gray-200">
            <img 
              src={infographicData.url} 
              alt="Infográfico gerado via DALL-E"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>
          {infographicData.description && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-sm text-blue-900">
                <span className="font-semibold">Descrição:</span> {infographicData.description}
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    );
  }

  // Se for um infográfico SVG (Gemini)
  if (infographicData.type === 'svg' && infographicData.url) {
    return (
      <Card className="card">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="flex items-center gap-2">
              <BarChart3 className="w-5 h-5 text-blue-600" />
              Infográfico
            </CardTitle>
            <Badge variant="secondary">SVG Gemini</Badge>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg overflow-hidden bg-gray-50 border border-gray-200 p-4">
            <iframe 
              src={infographicData.url} 
              title="Infográfico gerado via Gemini"
              className="w-full h-96 border-0 rounded"
              sandbox="allow-same-origin"
              loading="lazy"
            />
          </div>
          {infographicData.description && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-sm text-blue-900">
                <span className="font-semibold">Descrição:</span> {infographicData.description}
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    );
  }

  // Fallback: se não for formato de imagem ou SVG, retornar aviso
  return (
    <Card className="card">
      <CardContent className="p-8 text-center">
        <BarChart3 className="w-12 h-12 text-gray-300 mx-auto mb-3" />
        <p className="text-gray-500">Formato de infográfico não suportado</p>
      </CardContent>
    </Card>
  );
};

export default Infographic;
